import { create } from "zustand";
import { persist } from "zustand/middleware";

const useZustandStore = create(persist(
	(setState) => ({
		name: "",
		setName: (name) => setState({ name }),
		defaultPageSize: 5,
		setDefaultPageSize: (defaultPageSize) => setState({ defaultPageSize }),
	}),
	{
		name: "template-frontend",
	},
));

useZustandStore.setState({
	name: "",
	defaultPageSize: 5,
});

export default useZustandStore;
